<template>
  <div>
    <nav
      class="navbar navbar-expand-lg shadow p-3 mb-5 bg-white rounded"
      style="height: 5em; margin-bottom: 2em !important"
    >
      <a class="navbar-brand" href="#">
        <span style="font-size: 1.5rem; font-weight: bold; color: #15356f"
          >Brightstar DST</span
        >
      </a>
      <h6 style="margin-bottom: 0">
        Retail Number: <b>{{ $route.params.retailId }}</b>
      </h6>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
    </nav>
    <div class="main-content">
      <div style="text-align: center; padding-bottom: 1em">
        <h1
          style="
            font-size: 4rem;
            font-weight: bold;
            color: #fbc408;
            text-shadow: 0px 3px 3px gray;
          "
        >
          Customer Display
        </h1>
      </div>
      <div style="text-align: center">
        <h4 class="card-title">
          Ticket ID: <b>{{ ticketId }}</b>
        </h4>
      </div>
      <div
        class="card qrcode-container"
        style="
          display: flex;
          flex-direction: row-reverse;
          align-items: stretch;
          background-color: #f7f7f7;
          margin-left: 30%;
          margin-right: 30%;
        "
      >
        <div
          style="
            width: 50%;
            align-self: center;
            text-align: left;
            margin-left: 1em;
          "
        >
          <vue-qrcode :value="qrcode" v-if="status === 'SALEABLE'" />
          <img
            style="width: 10%; opacity: 0.5; margin-left: 20%"
            class="img-placeholder"
            v-if="qrcode === undefined"
            src="../img/placeholder.png"
          />
          <div v-if="status === 'SOLD'" class="sold-ticket">
            <h1 style="margin-bottom: 0; margin-left: 20%; font-style: italic">
              <b>{{ status }}</b>
            </h1>
          </div>
          <div v-if="status === 'ON SALE'" class="onsale-ticket blink_me">
            <h1 style="margin-bottom: 0; margin-left: 20%; font-style: italic">
              <b>{{ status }}</b>
            </h1>
          </div>
        </div>
        <div
          style="
            width: 50%;
            margin-right: 1em;
            text-align: right;
            margin-right: 1em;
          "
        >
          <img
            style="width: 10%; opacity: 0.5; margin-right: 20%"
            class="img-placeholder"
            v-if="layout === undefined"
            src="../img/placeholder.png"
          />
          <img
            class="img"
            v-if="layout != undefined"
            v-bind:src="'data:image/jpeg;base64,' + layout"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * chiamare con /qrcode?id=<numeroid>
 */

import VueQrcode from '@chenfengyuan/vue-qrcode'
import restService from '../services/RestService'
import WSServiceSyncQRCode from '../services/WSServiceSyncQRCode'
import WSServiceUpdateTicket from '../services/WSServiceUpdateTicket'

export default {
  data() {
    return {
      qrcode: undefined,
      ticketId: undefined,
      status: undefined,
      layout: undefined,
    }
  },
  components: {
    VueQrcode,
  },
  async mounted() {
    function calculateQrCodeString(id) {
      var qrcodeString = {
        pubKeyAppLottery: '$pkl',
        idSellingTicket: id,
        appLotterySha3: '$als',
      }

      return qrcodeString
    }

    function calculateQrCode(id, retailId, timestamp, price) {
      // Use the browser's current hostname so the QR code always points to the
      // correct DST instance regardless of which network the machine is on.
      var dstRoot =
        window.location.protocol + '//' + window.location.hostname + ':8082'
      var qrcode =
        dstRoot +
        '\n' +
        JSON.stringify(calculateQrCodeString(id)) +
        '\n' +
        retailId +
        '\n' +
        timestamp +
        '\n' +
        price

      return qrcode
    }

    const removeItem = (items, i) =>
      items.slice(0, i - 1).concat(items.slice(i, items.length))

    let qrCodeResponse = await restService.getQRCode(
      this.$route.params.retailId,
    )
    this.ticketId = qrCodeResponse.id
    this.status = qrCodeResponse.status
    this.layout = qrCodeResponse.layout
    this.qrcode = calculateQrCode(
      qrCodeResponse.id,
      qrCodeResponse.retailId,
      qrCodeResponse.timestamp,
      qrCodeResponse.price,
    )

    WSServiceSyncQRCode.connect((notification) => {
      this.ticketId = JSON.parse(notification.body).id
      this.status = JSON.parse(notification.body).status
      this.layout = JSON.parse(notification.body).layout
      this.qrcode = calculateQrCode(
        JSON.parse(notification.body).id,
        JSON.parse(notification.body).retailId,
        JSON.parse(notification.body).timestamp,
        JSON.parse(notification.body).price,
      )
    }, this.$route.params.retailId)

    WSServiceUpdateTicket.connect((notification) => {
      this.ticketId = JSON.parse(notification.body).id
      this.status = JSON.parse(notification.body).status
    }, this.$route.params.retailId)
  },
}
</script>

<style>
.qrcode-container {
  padding: 1.5rem;
  margin-right: auto;
  margin-top: auto;
  margin-left: auto;
}
.sold-ticket {
  color: #f3711d;
}
.onsale-ticket {
  color: #fbc408;
}
.card {
  display: flex;
  flex-direction: row-reverse;
}
.img-placeholder {
  width: 15rem;
}
.img {
  width: 14rem;
}
.blink_me {
  animation: blinker 2s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.main-content {
  height: 100vh;
  background-color: #f0f4ff;
}
</style>
